module.exports = "/_next/static/images/DenisMezer-35e2408e8b6dbafaf4eb70d8ad26c909.webp";